import {getRequest} from "./ApiService";

export function getCertificateList(){
    return getRequest('certificateList')
}
